import styles from '../main/style.module.scss';
import { Col, Row, Spin, Table, Typography } from 'antd';
import useVipClub from '../useVipClub';
import { useTranslation } from 'react-i18next';
import BarChangeChart from '../../../charts/barChange';
import Helpers from '../../../../../helpers';
import PieChart from '../pieChart';
import { useMemo } from 'react';
import moment from 'moment/moment';

const Print = ({
  allReports = false,
  allReportsData,
  isAllReports,
  isMain,
}) => {
  const { t } = useTranslation();
  const {
    searchParams,
    format,
    loading,
    columsForMoreFiveThousand,
    allData,
    columsForPoints,
    columsForConventionType,
    columsForStatus,
    columsForCity,
    columsForTopCountry,
    columsForProfileType,
    columsForCompanyAmount,
  } = useVipClub(true, allReportsData, isAllReports);

  if (!isMain) {
    localStorage.setItem('auth_token', searchParams.get('token'));
  }

  const fromToText = useMemo(() => {
    const objSP = Object.fromEntries([...searchParams]);

    const to = objSP.date_to;

    return `al ${moment(to, 'DD-MM-YYYY').format('DD MMMM YYYY')}`;
  }, [searchParams]);

  return (
    <>
      <div className={styles.container}>
        <Spin spinning={loading}>
          <br />
          <Row gutter={[20, 20]}>
            <Col span={24}>
              <Typography.Title level={3}>{t('Brands over 5000 punti')} </Typography.Title>
              <Table
                columns={columsForMoreFiveThousand}
                dataSource={allData.moreFiveThousand}
                pagination={{
                  pageSize: 10000,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                scroll={{ x: 700 }}
              />
            </Col>
            <Col span={24}>
              <Typography.Title level={3}>
                {t('Distribuzione per tipologia punti')}
              </Typography.Title>
              <BarChangeChart
                keys={['Age']}
                data={allData.transactionTypeAll}
                formatTooltip={Helpers.changeDotToComa}
                lineItemWidth={180}
                itemWidth={160}
                // format={format}
                translateX={200}
                hideLine
                layout={'horizontal'}
                margin={{ top: 50, right: 0, bottom: 100, left: 230 }}
                hideLegend
                hideTooltipKey={true}
              />
            </Col>
            <Col span={24}>
              <Typography.Title level={3}>
                {t('Distribuzione punti infopoint')}
              </Typography.Title>
              <BarChangeChart
                keys={['Age']}
                data={allData.transactionInfo}
                formatTooltip={Helpers.changeDotToComa}
                lineItemWidth={180}
                itemWidth={160}
                // format={format}
                translateX={200}
                hideLine
                layout={'horizontal'}
                margin={{ top: 50, right: 0, bottom: 100, left: 230 }}
                hideLegend
                hideTooltipKey={true}
              />
            </Col>
            {/*<Col span={24}>*/}
            {/*  <Typography.Title level={3}>*/}
            {/*    {t('Distribuzione clienti per soglie')} {fromToText}*/}
            {/*  </Typography.Title>*/}
            {/*  <Table*/}
            {/*    columns={columsForPoints}*/}
            {/*    dataSource={allData.points}*/}
            {/*    pagination={{*/}
            {/*      pageSize: 10000,*/}
            {/*      position: ['bottomCenter'],*/}
            {/*      hideOnSinglePage: true,*/}
            {/*      showSizeChanger: false,*/}
            {/*    }}*/}
            {/*    bordered*/}
            {/*    scroll={{ x: 700 }}*/}
            {/*  />*/}
            {/*</Col>*/}
            <Col span={24}>
              <Typography.Title level={3}>
                {t('Convenzioni aziendali')}
              </Typography.Title>
              <Table
                columns={columsForConventionType}
                dataSource={allData.conventionType}
                pagination={{
                  pageSize: 10000,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                scroll={{ x: 700 }}
              />
            </Col>
            <Col span={24}>
              <Typography.Title level={3}>
                {t('Utenti totali')}: {allData.total_users}
              </Typography.Title>
            </Col>
            <Col span={24}>
              <Typography.Title level={3}>
                {t('Distribuzione soglie')}
              </Typography.Title>
              <Table
                columns={columsForStatus}
                dataSource={allData.status}
                pagination={{
                  pageSize: 10000,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                scroll={{ x: 700 }}
              />
            </Col>
            <Col span={24}>
              <Typography.Title level={3}>
                {`${t('Distribuzione soglie')} ${fromToText}`}
              </Typography.Title>
              <Table
                columns={columsForStatus}
                dataSource={allData.status_all}
                pagination={{
                  pageSize: 10000,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                scroll={{ x: 700 }}
              />
            </Col>
            <Col span={24}>
              <Typography.Title level={3}>
                {t('Top 10 Provincia')}
              </Typography.Title>
              <Table
                columns={columsForCity}
                dataSource={allData.city}
                pagination={{
                  pageSize: 10000,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                scroll={{ x: 700 }}
              />
            </Col>
            <Col span={24}>
              <Typography.Title level={3}>{t('Gender')}</Typography.Title>
              <Typography.Title level={3}>{t('Totale registrati')}: {allData.total_users}</Typography.Title>
              <div className={styles.pieChart}>
                <PieChart data={allData.sex} />
              </div>
            </Col>
            <Col span={24}>
              <Typography.Title level={3}>
                {t('TOP 10 Nazionalità')}
              </Typography.Title>
              <Table
                columns={columsForTopCountry}
                dataSource={allData.country}
                pagination={{
                  pageSize: 10000,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                scroll={{ x: 700 }}
              />
            </Col>
            <Col span={24}>
              <Typography.Title level={3}>{t('Fasce deta')}</Typography.Title>
              <Col span={24}>
                <BarChangeChart
                  keys={['Age']}
                  data={allData.barChartAge}
                  formatTooltip={Helpers.changeDotToComa}
                  lineItemWidth={180}
                  itemWidth={160}
                  format={format}
                  translateX={200}
                  hideLine
                />
              </Col>
              <Typography.Title level={3}>
                {t('Profilo extra')}
              </Typography.Title>

              <Table
                columns={columsForProfileType}
                dataSource={allData.profile_type}
                pagination={{
                  pageSize: 10000,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                scroll={{ x: 700 }}
              />
            </Col>

            <Col span={24}>
              <Typography.Title level={3}>{t('Tenant')}</Typography.Title>
              <Typography.Title level={3}>
                {t('Saldo Punti')}: {allData.total_amount}
              </Typography.Title>
              <Table
                columns={columsForCompanyAmount}
                dataSource={allData.companyAmount}
                pagination={{
                  pageSize: 10000,
                  position: ['bottomCenter'],
                  hideOnSinglePage: true,
                  showSizeChanger: false,
                }}
                bordered
                scroll={{ x: 700 }}
              />
            </Col>
          </Row>
        </Spin>

        {/*{(*/}
        {/*  <Spin spinning={loading}>*/}
        {/*    <br />*/}
        {/*    {!allReports && (*/}
        {/*      <Row className={styles.titleSection} justify={'center'}>*/}
        {/*        <Col>*/}
        {/*          <Typography.Title level={3}>{title}</Typography.Title>*/}
        {/*        </Col>*/}
        {/*        <PrintFilterText*/}
        {/*          availableFilters={availableFilters}*/}
        {/*          searchParams={searchParams}*/}
        {/*        />*/}
        {/*      </Row>*/}
        {/*    )}*/}
        {/*    {allReports && (*/}
        {/*      <Row className={styles.titleSection} justify={'center'}>*/}
        {/*        <Col>*/}
        {/*          <Typography.Title level={3}>Footfall</Typography.Title>*/}
        {/*        </Col>*/}
        {/*      </Row>*/}
        {/*    )}*/}
        {/*    <br />*/}
        {/*    <Row>*/}
        {/*      <Col span={24}>*/}
        {/*        <Table*/}
        {/*          columns={columns}*/}
        {/*          dataSource={data.tableData}*/}
        {/*          pagination={{*/}
        {/*            pageSize: 10000,*/}
        {/*            position: ['bottomCenter'],*/}
        {/*            hideOnSinglePage: true,*/}
        {/*            showSizeChanger: false,*/}
        {/*          }}*/}
        {/*          bordered*/}
        {/*          scroll={{ x: 700 }}*/}
        {/*          summary={summary}*/}
        {/*        />*/}
        {/*      </Col>*/}
        {/*      <Col span={24}>*/}
        {/*        <Row className={'chartColl'}>*/}
        {/*          <Col span={12}>*/}
        {/*            <LineChart*/}
        {/*              data={data.lineChartData}*/}
        {/*              tableData={data.tableData}*/}
        {/*              colors={['#61cdbb', '#f47560']}*/}
        {/*            />*/}
        {/*            <BarChangeChart*/}
        {/*              data={data}*/}
        {/*              format={format}*/}
        {/*              keys={['Footfall LY', 'Footfall YTD']}*/}
        {/*            />*/}
        {/*          </Col>*/}
        {/*        </Row>*/}
        {/*      </Col>*/}
        {/*    </Row>*/}
        {/*  </Spin>*/}
        {/*)}*/}
      </div>
    </>
  );
};

export default Print;
